// Application

export default class Application {
  constructor() {
    this.scrollingDisabled = false;
    this.scrollingY = 0;

    document.addEventListener('readystatechange', this.handleReadyState.bind(this));
    this.handleReadyState();
  }

  // Event Handlers: Ready State Change

  handleReadyState() {
    switch (document.readyState) {
      case 'interactive': this.handleReadyStateInteractive(); break;
      case 'complete': this.handleReadyStateComplete(); break;
    }
  }

  handleReadyStateInteractive() {
    this.resizeTimeout = null;
    window.addEventListener('resize', this.handleResize.bind(this));
    this.handleResize();

    this.scrollTimeout = null;
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.handleScroll();
  }

  handleReadyStateComplete() {
  }

  // Event Handlers: Resize

  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(this.handleResizeFinished.bind(this), 100);
  }

  handleResizeFinished() {
  }

  // Event Handlers: Scroll

  handleScroll() {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(this.handleScrollFinished.bind(this), 100);
  }

  handleScrollFinished() {
  }

  // Global Scrolling

  disableScrolling() {
    if (this.scrollingDisabled) { return; }

    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';

    this.scrollingDisabled = true;
    this.scrollingY = scrollY;
  }

  enableScrolling() {
    if (!this.scrollingDisabled) { return; }

    const scrollY = this.scrollingY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);

    this.scrollingDisabled = false;
    this.scrollingY = 0;
  }

  getScrollY() {
    if (this.scrollingDisabled) {
      return this.scrollingY;
    } else {
      return window.scrollY;
    }
  }

  // Local Scrolling

  scrollToHash(hash) {
    if (!hash) { return; }

    const element = document.querySelector(hash);
    if (!element) { return; }

    window.scrollTo({
      top: element.offsetTop,
      left: 0,
      behavior: 'smooth'
    });
  }
}
